<template lang="pug">
el-dialog(title="团队成员" :visible="visible" :before-close="hide")
    el-select.add-member(
        v-model="search"
        filterable
        clearable
        remote
        placeholder="请输入待邀请成员的账号关键词"
        :remote-method="listOrgMembers"
        :loading="loading"
        @change="addTeamMember")
        el-option(
            v-for="item in orgMembers"
            :key="item.user.name"
            :label="item.user.displayName"
            :value="item.user.name")
            span(style="float: left") {{ item.user.displayName }}
            span(style="float: right; color: #8492a6; font-size: 13px") {{ item.user.name }}

    el-table(v-bind:data="creatingMembers" :header-cell-style="tableHeaderColor" max-height="560px")
            el-table-column(prop="username" label="账号")
            el-table-column(prop="orgRole" label="组织角色" label-width="160px")
                template(slot-scope="scope")
                    el-select.change-teamRole(v-model="scope.row.teamRole" size="mini")
                        el-option(v-for="item in teamRoleOptions" :key="item.value" :label="item.label" :value="item.value")

    .dialog-footer(slot="footer")
        el-button(@click="hide") 取 消
        el-button(type="primary" @click="submit" :loading="loading") 确 定
</template>

<script>
import {
    getUserOrgsAPI,
    listOrgMembersAPI,
    createTeamMemberAPI,
    getTeamMembershipAPI
} from "@/services";
export default {
    name: "inviteTeamMember",
    props: ["visible", "teamId"],
    data() {
        return {
            loading: false,
            search: "",
            org: {},
            orgMembers: [],
            creatingMembers: [],
            teamRoleOptions: [
                {
                    value: "admin",
                    label: "团队管理员"
                },
                {
                    value: "member",
                    label: "团队成员"
                }
            ]
        };
    },
    methods: {
        /**
         * Backend Service API Func Wrapper
         */
        async getUserOrgs() {
            this.loading = true;
            try {
                const res = await getUserOrgsAPI({
                    name: localStorage.getItem("account")
                });
                if (res.status === 200 && res.data.length) {
                    this.org = Object.assign({}, res.data[0].org);
                }
            } catch {
                console.log(localStorage.getItem("account"));
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        async listOrgMembers(keyword) {
            this.loading = true;
            try {
                const res = await listOrgMembersAPI(this.org.name, {
                    name: keyword,
                    limit: 0
                });
                if (res.status === 200) {
                    this.orgMembers = res.data.data;
                } else {
                    throw err;
                }
            } catch (err) {
                console.log("获取组织成员列表失败");
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        async createTeamMember() {
            this.loading = true;
            try {
                const res = await createTeamMemberAPI(
                    this.teamId,
                    this.creatingMembers[0]
                );
                if (res.status === 201) {
                    this.$message.success("保存成功");
                    this.$emit("refresh");
                } else {
                    throw err;
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        async checkTeamMembership(username) {
            try {
                const res = await getTeamMembershipAPI(this.teamId, username);
                if (res.status === 204) {
                    return true;
                } else if (res.sattus === 404) {
                    return false;
                } else {
                    throw err;
                }
            } catch (err) {
                console.log(err);
                this.$message.error("服务器开小差了，请尝试重新操作");
            }
        },
        async addTeamMember(val) {
            if (this.creatingMembers.length !== 0) {
                this.$message.warning("暂不支持批量添加");
                return false;
            }
            try {
                const res = await getTeamMembershipAPI(this.teamId, val);
                if (res.status === 204) {
                    this.$message.warning("用户已在团队内");
                    return false;
                }
            } catch (err) {
                if (err.status === 404) {
                    this.creatingMembers.push({
                        username: val,
                        teamRole: "member"
                    });
                } else {
                    console.log(err);
                    this.$message.error("服务器开小差了，请尝试重新操作");
                }
            }
        },
        /**
         * UI Control
         */
        hide() {
            this.$emit("hide");
        },
        submit() {
            this.createTeamMember();
            this.hide();
        },
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "background-color: #f2f2f2;color: #8493A8;";
            }
        }
    },
    watch: {
        visible(val) {
            if (!val) {
                this.creatingMembers = [];
            }
        }
    },
    mounted() {
        this.getUserOrgs();
    }
};
</script>
<style lang="stylus" scoped>
.el-dialog__body {
    padding-top: 10px;
}

.add-member {
    width: 100%;
    margin-top: -50px;
    margin-bottom: 10px;
}

.change-teamRole {
    width: 100%;
    height: 50%;
}
</style>
